<template>
  <div>
    <!-- Header -->
    <b-col
      lg="12"
      md="12"
      sm="12"
      class="mb-1"
    >
      <div class="d-flex justify-content-between align-items-center">
        <b-link
          class="page-header"
          @click="checkTotal(deptid)"
        >
          <feather-icon
            class="back-icon"
            size="34"
            icon="ArrowLeftIcon"
          />
          <span class="title">WIM Dashboard : </span>
          <span class="station">{{ waydetail }}</span>
        </b-link>

        <div>
          <b-button
            :href="anydesk"
            class="mr-1"
            size="sm"
            title="กดเพื่อดูเพิ่มเติม"
            variant="outline-danger"
          >
            <b-img
              src="@/assets/images/logo/anydesk.png"
              style="height: 16px; width: 16px;"
            />
          </b-button>
        </div>
      </div>
    </b-col>

    <b-row class="match-height">
      <!-- Left Column -->
      <b-col
        lg="4"
        md="12"
        sm="12"
      >
        <b-row class="match-height">
          <!-- Map -->
          <b-col lg="12">
            <div
              v-if="mapLoading"
              class="loading-container"
            >
              <b-spinner
                variant="light"
                label="Loading map..."
              />
              <span class="loading-text">กำลังโหลดแผนที่...</span>
            </div>
            <div
              v-else-if="mapError"
              class="error-container"
            >
              {{ mapError }}
              <b-button
                size="sm"
                variant="outline-light"
                @click="getMarker"
              >
                ลองใหม่
              </b-button>
            </div>
            <l-map
              v-else
              ref="mymap"
              :zoom="zoom"
              :center="center"
              class="map-container"
              :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false}"
            >
              <l-tile-layer :url="url" />
              <l-marker
                v-for="(marker, index) in markers"
                :key="'marker'+index"
                :ref="'marker'+index"
                :lat-lng="[marker.Latitude, marker.Longtitude]"
                :options="{ autoClose: false, closeOnClick: false }"
                @click="stream(marker.RTSP_HLS, marker.Camera_Desc)"
              >
                <l-icon
                  :icon-size="[28, 40]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/icons/MakerCCTV.svg')"
                />
              </l-marker>
            </l-map>
          </b-col>

          <!-- RTSP Component -->
          <b-col lg="12">
            <WIMRTSP />
          </b-col>
        </b-row>
      </b-col>

      <!-- Right Column -->
      <b-col lg="8">
        <b-row>
          <b-col lg="12">
            <WIMStatistics />
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6">
            <WIMBarChart />
          </b-col>
          <b-col lg="6">
            <WIMSpeedLineChart />
          </b-col>
          <b-col lg="6">
            <WIMTrendLineChart />
          </b-col>
          <b-col lg="6">
            <WIMTOP5BarChart />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Hls from 'hls.js'
import {
  BRow, BCol, BLink, BSpinner, BButton, BImg,
} from 'bootstrap-vue'
import {
  LMap, LTileLayer, LMarker, LIcon,
} from 'vue2-leaflet'
import axios from '@axios'
import { Icon } from 'leaflet'
import WIMStatistics from './WIMStatistics.vue'
import WIMRTSP from './WIMRTSP.vue'
import WIMBarChart from './WIMBarChart.vue'
import WIMSpeedLineChart from './WIMSpeedLineChart.vue'
import WIMTrendLineChart from './WIMTrendLineChart.vue'
import WIMTOP5BarChart from './WIMTOP5BarChart.vue'

// Import Leaflet CSS
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'

// Fix Leaflet icon issue
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  // eslint-disable-next-line global-require
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  // eslint-disable-next-line global-require
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  // eslint-disable-next-line global-require
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  name: 'WIMDashboard',

  components: {
    BRow,
    BCol,
    BLink,
    BSpinner,
    BButton,
    LMap,
    BImg,
    LTileLayer,
    LMarker,
    LIcon,
    WIMStatistics,
    WIMRTSP,
    WIMBarChart,
    WIMSpeedLineChart,
    WIMTrendLineChart,
    WIMTOP5BarChart,
  },

  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 16,
      center: [0, 0],
      waydetail: '',
      markers: [],
      anydesk: '',
      anydesk1: '',
      deptid: '',
      userData: JSON.parse(localStorage.getItem('userData')),
      mapLoading: false,
      mapError: null,
      streamError: null,
    }
  },

  mounted() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', true)
    this.initializeMap()
  },

  methods: {
    initializeMap() {
      this.getMarker()
      this.getWimData()
      this.$nextTick(() => {
        if (this.$refs.mymap) {
          const map = this.$refs.mymap.mapObject
          map.addControl(new window.L.Control.Fullscreen())
        }
      })
    },

    async getMarker() {
      if (this.mapLoading) return

      this.mapLoading = true
      this.mapError = null

      try {
        const response = await axios.post('https://wts.drr.go.th/node-red/get-Station-WIM',
          { wid: this.$route.query.wid },
          {
            headers: { 'Content-Type': 'application/json' },
            timeout: 10000,
          })

        this.markers = response.data
        this.center = [response.data[0].Latitude, response.data[0].Longtitude]
        this.waydetail = response.data[0].StationDescription
      } catch (error) {
        console.error('Error loading map data:', error)
        this.mapError = 'ไม่สามารถโหลดข้อมูลแผนที่ได้'
      } finally {
        this.mapLoading = false
      }
    },
    checkTotal(value) {
      axios
        .post('/checkWIMTotal', { DeptID: value })
        .then(response => {
          if (response.data[0].count_deptid > 1) {
            this.$router.push({ path: '/wim-sub', query: { DeptID: value } })
          } else {
            this.$router.push({ path: '/wim-total' })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    async getWimData() {
      try {
        const response = await axios.post('/getWimData',
          { wid: this.$route.query.wid },
          {
            headers: { 'Content-Type': 'application/json' },
            timeout: 10000,
          })

        this.anydesk = `anydesk:${response.data[0].anydesk}`
        this.anydesk1 = response.data[0].anydesk
        this.deptid = response.data[0].deptid
      } catch (error) {
        console.error('Error loading map data:', error)
      }
    },

    stream(value, camdesc) {
      setTimeout(() => {
        try {
          this.camdesc = camdesc
          const hls = new Hls({
            lowLatencyMode: true,
            autoreconnect: true,
          })

          const stream = value
          const video = document.querySelector('#video')

          if (!video) {
            console.error('Video element not found')
            return
          }

          hls.loadSource(stream)
          hls.attachMedia(video)

          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            video.play().catch(e => console.error('Error playing video:', e))
          })

          hls.on(Hls.Events.ERROR, (event, data) => {
            console.error('HLS Error:', data)
            video.play().catch(e => console.error('Error playing video:', e))
          })
        } catch (error) {
          console.error('Error initializing stream:', error)
          this.streamError = 'ไม่สามารถเล่นวิดีโอได้'
        }
      }, 500)
    },
  },
}
</script>

<style lang="scss" scoped>
.page-header {
  font-size: 26px;
  color: #fff;

  .back-icon {
    margin-bottom: 5px;
  }

  .title {
    color: #00FF80;
  }

  .station {
    color: #fff;
  }
}

.map-container {
  width: 100%;
  height: 230px;
  border: 2px solid #000;
  border-radius: 10px;
}

.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 350px;
  color: #fff;
  gap: 1rem;
  border: 2px solid #000;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}

.loading-text {
  margin-top: 0.5rem;
  color: #fff;
}

// Leaflet popup styles
.leaflet-popup-content {
  margin: 10px;
  width: 250px;
  height: 100%;
}

.leaflet-container a.leaflet-popup-close-button {
  padding: 0;
}

.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
  background: rgba(36, 36, 36, 0.95);
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);
  border: 1px solid #00B058;
  border-radius: 12px;
}
</style>
